/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Add_TrackInputs */



/**
* | output |
* | --- |
* | "Add track" |
*
* @param {Audio_Embed_Export_Add_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_add_track = /** @type {((inputs?: Audio_Embed_Export_Add_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Add_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Track hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить трек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加曲目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar faixa")
	return /** @type {LocalizedString} */ ("Add track")
});